import React from 'react';
import { WebsiteDesignProps } from './types';
import { Send, FileText, ChevronRight } from 'lucide-react';
import { Button } from "@/components/ui/button";

const OrigamiFold: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Paper Plane High";

    return (
        <div className="bg-gray-100 min-h-screen font-sans text-gray-800">
            <nav className="p-8 flex justify-between items-center bg-white shadow-sm relative z-20" style={{clipPath: 'polygon(0 0, 100% 0, 100% 85%, 0 100%)'}}>
                <div className="text-2xl font-bold uppercase tracking-widest text-[#555] flex items-center gap-2">
                    <Send className="transform -rotate-45" /> {schoolName}
                </div>
                <Button className="bg-gray-800 text-white rounded-none hover:bg-gray-700 skew-x-[-10deg]">
                    <span className="skew-x-[10deg] uppercase font-bold tracking-widest text-xs">Admissions</span>
                </Button>
            </nav>

            <main className="container mx-auto px-6 py-12 relative z-10">
                 <div className="flex flex-col items-center">
                     <div className="w-full max-w-4xl bg-white shadow-xl relative overflow-hidden" style={{clipPath: 'polygon(0% 0%, 100% 0%, 100% 90%, 50% 100%, 0% 90%)'}}>
                         <div className="bg-gray-800 text-white p-16 text-center pb-24">
                             <h1 className="text-4xl md:text-6xl font-black uppercase tracking-widest mb-4">
                                 Unfold Your <br/> Potential
                             </h1>
                             <div className="w-16 h-1 bg-white mx-auto mb-8"></div>
                             <p className="text-gray-400 max-w-lg mx-auto leading-relaxed">
                                 Like a blank sheet of paper, your future is waiting to be shaped. We provide the creases and folds to guide you.
                             </p>
                         </div>
                     </div>
                     
                     {/* Overlapping Card */}
                     <div className="w-full max-w-3xl bg-[#f0f0f0] p-8 -mt-16 text-center shadow-lg transform rotate-1 border border-white">
                         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                             {[
                                 { title: "Precision", desc: "Attention to every detail." },
                                 { title: "Artistry", desc: "Beauty in structure." },
                                 { title: "Vision", desc: "Seeing the final form." }
                             ].map((item, i) => (
                                 <div key={i} className="p-4 bg-white shadow-sm">
                                     <h3 className="font-bold uppercase text-sm mb-2 text-gray-400">{item.title}</h3>
                                     <p className="text-sm font-medium">{item.desc}</p>
                                 </div>
                             ))}
                         </div>
                     </div>
                 </div>

                 <div className="mt-20 flex justify-center">
                     <Button variant="ghost" className="text-gray-400 hover:text-gray-800 uppercase tracking-[0.3em] font-bold text-xs flex items-center gap-2">
                         Explore Programs <ChevronRight size={16} />
                     </Button>
                 </div>
            </main>
        </div>
    );
};

export default OrigamiFold;
